export function getAllOecdDescriptions(axiosPrivate) {
  return axiosPrivate.get('/oecd-descriptions')
}

export function getOecdDescriptionById(axiosPrivate, id) {
  return axiosPrivate.get(`/oecd-descriptions/${id}`)
}

export function createOecdDescription(axiosPrivate, data) {
  return axiosPrivate.post('/oecd-descriptions', data)
}

export function updateOecdDescriptionById(axiosPrivate, id, data) {
  return axiosPrivate.put(`/oecd-descriptions/${id}`, data)
}

export function deleteOecdDescription(axiosPrivate, id) {
  return axiosPrivate.delete(`/oecd-descriptions/${id}`)
}
